/**
 * The wire shape `Rws.AiInsights.Host.Mcp.Commands.McpCommandRetentionEndpoints` returns: how long the
 * portal keeps the receipt of a finished MCP command, which is how long a client's retry with the same
 * operation key still returns the original answer. Gated on `settings.write`.
 */
import { adminRequest, type AdminResult } from "./adminApi";

/** The receipt retention, in the whole hours an administrator edits. */
export interface McpCommandRetention {
  hours: number;
  /** When the value was last saved, or `null` while the default applies. */
  updatedAt: string | null;
  /** The longest retention an administrator may save, from the server's configuration. */
  maximumHours: number;
}

const mcpCommandRetentionPath = "/api/entitlement/settings/mcp-command-retention";

/** Calls `GET /api/entitlement/settings/mcp-command-retention`. */
export async function fetchMcpCommandRetention(): Promise<AdminResult<McpCommandRetention>> {
  return adminRequest<McpCommandRetention>(mcpCommandRetentionPath, { method: "GET" }, "MCP command retention");
}

/** Calls `PUT /api/entitlement/settings/mcp-command-retention`. */
export async function updateMcpCommandRetention(hours: number): Promise<AdminResult<McpCommandRetention>> {
  return adminRequest<McpCommandRetention>(
    mcpCommandRetentionPath,
    { method: "PUT", body: JSON.stringify({ hours }) },
    "MCP command retention update",
  );
}
